var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._g(_vm._b({directives:[{name:"bind-observe",rawName:"v-bind-observe"}],staticClass:"ua-image",style:({
    aspectRatio: _vm.aspectRatio
  }),attrs:{"src":_vm.innerSrc,"data-src":_vm.src,"alt":"图片"}},'img',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }